import React, { lazy, Suspense } from "react";
import { Route, Routes as Router } from "react-router";

import {
  CLUB_DETAILS,
  CREATE_CLUB,
  DASHBOARD,
  EMAIL_VERIFICATION,
  HOME,
  MARKETPLACE,
  NOT_FOUND,
  OFFER,
  USER_ACCOUNT_SETTINGS,
} from "./common/constants/routes.constants";
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary";
import Navbar from "./components/Navbar/Navbar";
import BrowseClubs from "./pages/BrowseClubs/BrowseClubs";
import BuySellNftPage from "./pages/BuySellNFtPage/BuySellNftPage";
import CreateClubWizard from "./pages/CreateClubWizardPage/CreateClubWizard";
import EmailVerification from "./pages/EmailVerification/EmailVerification";
import Marketplace from "./pages/Marketplace/Marketplace";
import NotFound from "./pages/NotFound/NotFound";
import UserDashboardPage from "./pages/UserDashboardPage/UserDashboardPage";
import Vault from "./pages/Vault/Vault";

const ClubDetails = lazy(() => import("./pages/ClubDetails/ClubDetails"));

const REACT_APP_HIDE_BROWSE_CLUBS = process.env.REACT_APP_HIDE_BROWSE_CLUBS;

const Routes: React.FC = () => {
  return (
    // todo@arsa: create loading screen
    <Suspense fallback={<div>loading...</div>}>
      <Navbar />
      <ErrorBoundary>
        <div className="main-container">
          <Router>
            <Route
              element={
                REACT_APP_HIDE_BROWSE_CLUBS !== "true" ? (
                  <BrowseClubs />
                ) : (
                  <UserDashboardPage />
                )
              }
              path={HOME}
            />

            <Route element={<CreateClubWizard />} path={CREATE_CLUB} />
            <Route
              element={<BuySellNftPage />}
              path={`${OFFER}/:proposalAddress/:clubAddress`}
            />
            <Route
              element={<ClubDetails />}
              path={`${CLUB_DETAILS}/:clubAddress`}
            />
            <Route
              element={<EmailVerification />}
              path={`${EMAIL_VERIFICATION}/:verificationId`}
            />
            <Route
              element={<Vault />}
              path={`${CLUB_DETAILS}/:clubAddress/vault/:clubName`}
            />
            <Route path={DASHBOARD} element={<UserDashboardPage />} />
            <Route
              path={`${DASHBOARD + USER_ACCOUNT_SETTINGS}`}
              element={<UserDashboardPage />}
            />
            <Route element={<NotFound notFound={true} />} path={NOT_FOUND} />
            <Route element={<Marketplace />} path={MARKETPLACE} />
          </Router>
        </div>
      </ErrorBoundary>
    </Suspense>
  );
};

export default Routes;
